import './styles.css'

import * as THREE from 'three/src/Three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
//import { GUI } from 'three/examples/jsm/libs/lil-gui.module.min.js'
import { VRButton } from 'three/examples/jsm/webxr/VRButton'
import TouchTexture from './TouchTexture'
import { colorTemperature2rgb } from 'color-temperature'

import { scaleLinear } from 'd3-scale'

import starsVert from './shaders/stars.vert'
import starsFrag from './shaders/stars.frag'

import planeVert from './shaders/plane.vert'
import planeFrag from './shaders/plane.frag'

import TWEEN from 'three/examples/jsm/libs/tween.module.min.js'
import { starTexture } from './texture.js'

import starsData from './data/stars.json'
import starsData1 from './data/stars_ra_dec.json'

//import logo from './assets/tts_thin.png'

let camera, scene, renderer, controls, stars, texture, logomesh
let params, material, planeMat, user, touchTexture

let clock = new THREE.Clock()

let starId = []
let starNames = []
let starConst = []

let raycaster, intersects;
let pointer, INTERSECTED;

let windowHalfX = window.innerWidth / 2
let windowHalfY = window.innerHeight / 2

let mouse = {
	screenSpace: {
		x: 0.5,
		y: 0.5
	},
	cartesian: {
		x: 0,
		y: 0
	}
}

//const gui = new GUI()

const init = async () => {
	var loading = document.getElementById('loading')
	var title = document.getElementById('title')
	var container = document.getElementById('container')

	camera = new THREE.PerspectiveCamera(
		45,
		window.innerWidth / window.innerHeight,
		0.1,
		100000,
	)

	scene = new THREE.Scene()
	scene.background = new THREE.Color(0x000000)

	renderer = new THREE.WebGLRenderer({
		antialias: false,
		logarithmicDepthBuffer: true,
	})
	renderer.setPixelRatio(window.devicePixelRatio)
	renderer.setSize(window.innerWidth, window.innerHeight)
	container.appendChild(renderer.domElement)

	window.addEventListener('resize', onWindowResize, false)
	window.addEventListener('mousemove', onMouseMove, false)
	window.addEventListener('touchmove', onTouchMove, false)

	camera.position.set(0, 0, 500)

	raycaster = new THREE.Raycaster()
	pointer = new THREE.Vector2();

	params = {
		sizeSystem: 1,
		coordSystem: 1,
		minSize: 8 * window.devicePixelRatio,
		distanceMult: 50000 * window.devicePixelRatio,
	}

	//controlsSetup()

	touchTexture = new TouchTexture()
	touchTexture.initTexture()

	texture = starTexture(renderer)

	await skyMap()
	//addLogo()
	//xrSetup()
	eclipticPlane()
	//guiSetup()
	console.log('loaded')
	loading.remove()
	//Animate Title
	title.classList.add("animOpac");

	animate()
	tweenSpherical()
	//tweenLogo()

	console.log(TWEEN)
}

// const guiSetup = () => {
// 	gui.add(params, 'sizeSystem', 0, 1).onChange((value) => {
// 		material.uniforms.uSizeSystem.value = params.sizeSystem
// 	})
// 	gui.add(params, 'coordSystem', 0, 1).onChange((value) => {
// 		material.uniforms.uCoordSystem.value = params.coordSystem
// 	})
// 	gui.add(params, 'minSize', 0, 20).onChange((value) => {
// 		material.uniforms.uMinSize.value = params.minSize
// 	})
// 	gui.add(params, 'distanceMult', 0, 100000).onChange((value) => {
// 		material.uniforms.uDistanceMult.value = params.distanceMult
// 	})
// }

const controlsSetup = () => {
	controls = new OrbitControls(camera, renderer.domElement)
	controls.enabled = false;
	controls.enableDamping = true
	controls.target = new THREE.Vector3(0, 0, 0)
	controls.autoRotate = true
	controls.autoRotateSpeed = 0.25
}

const xrSetup = () => {
	// AUGMENTED REALITY STUFF
	renderer.xr.enabled = true
	//document.body.appendChild(ARButton.createButton(renderer))
	document.body.appendChild(VRButton.createButton(renderer))

	renderer.xr.addEventListener('sessionstart', () => {
		user = new THREE.Group()
		scene.add(user)
		user.add(camera)
		user.position.set(0, 0, 0)
	})

	renderer.xr.addEventListener('sessionend', () => {
		camera.position.set(0, 0, 0)
		user.remove(camera)
		scene.remove(user)
		user.position.set(0, 0, 0)
		user = null
	})
}

const tweenSpherical = () => {
	//TWEEN.removeAll()

	new TWEEN.Tween(material.uniforms.uCoordSystem)
		.to({ value: 0 }, 1000)
		.easing(TWEEN.Easing.Sinusoidal.InOut)
		.start()
}

const tweenLogo = () => {
	//TWEEN.removeAll()

	new TWEEN.Tween(logomesh.material)
		.to({ opacity: 1 })
		.delay(1000)
		.easing(TWEEN.Easing.Sinusoidal.InOut)
		.start()
}

// const loadLogo = () => {
// 	return new Promise((resolve) => {
// 		new THREE.TextureLoader().load(logo,
// 			(texture) => {
// 			resolve()
// 			}
// 		)
// 	})
// }

const skyMap = () => {
	return new Promise((resolve) => {
		let cPositions = []
		let sPositions = []
		let colours = []
		let absMag = []
		let appMag = []
		let brightness = []
		let starSize = []

		let radius = scaleLinear([6, -1], [0, 2])

		// THE STARS THAT CONSTITUTE THE CONSTELLATION OF ORION FROM THE HR CATALOGUE
		let orion = [
			1713, 2061, 1790, 1903, 1948, 2004, 1852, 1899, 1543, 1788, 1879, 1735,
			1552, 1567, 1931, 1580, 1907, 2124, 1784, 1839,
		]

		// TAKE THE STARS HR NUMBER
		// ABSOLUTE MAGNITUED
		// CARTESIAN XYZ COORDINATES FROM THE CATALOGUE

		for (const { id, name, constellation, tempK, magnitude, apparentMagnitude, radiusKm, distance, ra, dec } of starsData1) {
			if (distance !== null) {

				let absMagnitude = -magnitude * 0.2//radius(magnitude) * 0.2
				let appMagnitude = radius(apparentMagnitude) * 0.2
				let starSizeAdjusted = radiusKm * magnitude * 0.000000025



				//let temp = new THREE.Spherical().setFromCartesianCoords(x, y, z)

				let skyPositions = new THREE.Vector3().setFromSphericalCoords(
					1,
					Math.PI / 2 - THREE.MathUtils.degToRad(dec),
					Math.PI / 2 - THREE.MathUtils.degToRad(ra),
				)

				let actualPositions = new THREE.Vector3().setFromSphericalCoords(
					distance,
					Math.PI / 2 - THREE.MathUtils.degToRad(dec),
					Math.PI / 2 - THREE.MathUtils.degToRad(ra),
				)

				//IF THE STAR IS IN ORION ELARGE IT
				// for (const element of orion) {
				// 	if (element === id) {
				// 		absMagnitude *= 4;
				// 		appMagnitude *= 4;
				// 	}
				// }
				starNames.push(name)
				starId.push(id)
				starConst.push(constellation)

				absMag.push(absMagnitude)
				appMag.push(appMagnitude)
				starSize.push(starSizeAdjusted)
				brightness.push(1)
				cPositions.push(actualPositions.x, actualPositions.y, actualPositions.z)
				sPositions.push(skyPositions.x, skyPositions.y, skyPositions.z)

				let rgb = colorTemperature2rgb(tempK)
				colours.push(rgb.red / 255, rgb.green / 255, rgb.blue / 255)
			}
		}

		const geometry = new THREE.BufferGeometry()

		geometry.setAttribute(
			'position',
			new THREE.Float32BufferAttribute(cPositions, 3),
		)

		geometry.setAttribute(
			'sPosition',
			new THREE.Float32BufferAttribute(sPositions, 3),
		)

		geometry.setAttribute(
			'starSize',
			new THREE.Float32BufferAttribute(starSize, 1),
		)

		geometry.setAttribute(
			'colour',
			new THREE.Float32BufferAttribute(colours, 3),
		)

		geometry.setAttribute('absMag', new THREE.Float32BufferAttribute(absMag, 1))

		geometry.setAttribute('appMag', new THREE.Float32BufferAttribute(appMag, 1))

		geometry.setAttribute(
			'brightness',
			new THREE.Float32BufferAttribute(brightness, 1),
		)

		material = new THREE.ShaderMaterial({
			uniforms: {
				//color: { value: new THREE.Color(0xffffff) },
				uCoordSystem: { value: params.coordSystem },
				uSizeSystem: { value: params.sizeSystem },
				uMinSize: { value: params.minSize },
				uDistanceMult: { value: params.distanceMult },
				starTexture: {
					value: texture,
				},
				uDistort: new THREE.Uniform(touchTexture.texture),
			},
			vertexShader: starsVert,
			fragmentShader: starsFrag,
			transparent: true,
			depthWrite: false,
			blending: THREE.AdditiveBlending,
			side: THREE.FrontSide,
		})

		stars = new THREE.Points(geometry, material)
		scene.add(stars)
		resolve()
	})
}

const eclipticPlane = () => {
	const size = 1000
	// const divisions = 100
	// const gridHelper = new THREE.GridHelper(size, divisions, 0x333333, 0x111111)
	// scene.add(gridHelper)

	planeMat = new THREE.ShaderMaterial({
		uniforms: {
			color: { value: new THREE.Color(0xffffff) },
			uTime: { value: null },
			uResolution: {
				value: new THREE.Vector2(window.innerWidth, window.innerHeight),
			},
		},
		vertexShader: planeVert,
		fragmentShader: planeFrag,
		transparent: true,
		depthWrite: false,
		blending: THREE.AdditiveBlending,
		side: THREE.DoubleSide,
	})

	//const planeMat = new THREE.MeshBasicMaterial({ color: 0x111111, side: THREE.DoubleSide });
	const planeGeom = new THREE.PlaneGeometry(size, size, 1, 1)
	const planeMesh = new THREE.Mesh(planeGeom, planeMat)
	planeMesh.rotation.x = Math.PI / 2

	scene.add(planeMesh)
}

// const addLogo = () => {
// 	const logotex = new THREE.TextureLoader().load(logo);
// 	const logogeom = new THREE.PlaneGeometry(500, 500);
// 	const logomat = new THREE.MeshBasicMaterial({ alphaMap: logotex, side: THREE.DoubleSide, transparent: true });
// 	logomesh = new THREE.Mesh(logogeom, logomat);
// 	logomesh.material.opacity = 0;
// 	scene.add(logomesh);
// }

const animate = () => {
	requestAnimationFrame(animate)
	render()
}

const onWindowResize = () => {
	camera.aspect = window.innerWidth / window.innerHeight
	camera.updateProjectionMatrix()

	renderer.setSize(window.innerWidth, window.innerHeight)

	planeMat.uniforms.uResolution.value = new THREE.Vector2(window.innerWidth, window.innerHeight)
}

const onTouchMove = (ev) => {
	const touch = ev.targetTouches[0]
	onMouseMove({ clientX: touch.clientX, clientY: touch.clientY })
}

const onMouseMove = (ev) => {
	mouse = {
		screenSpace: {
			x: ev.clientX / window.innerWidth,
			y: 1 - ev.clientY / window.innerHeight
		},
		cartesian: {
			x: ev.clientX - windowHalfX,
			y: ev.clientY - windowHalfY
		}
	}

	pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
	pointer.y = - (event.clientY / window.innerHeight) * 2 + 1;

	touchTexture.addTouch(mouse.screenSpace)

	// raycaster.setFromCamera(
	// 	{
	// 		x: mouse.cartesian.x,
	// 		y: mouse.cartesian.y
	// 	},
	// 	camera
	// )

	//material.uniforms.uMouse.value.set(mouse.ssX, mouse.ssY)
	//particleMaterial0.uniforms.uMouse.value.set(mouse.ssX, mouse.ssY)
}

const render = () => {
	TWEEN.update()

	touchTexture.update()

	let dt = clock.getDelta()

	planeMat.uniforms.uTime.value += dt

	//logomesh.quaternion.copy(camera.quaternion);
	stars.rotation.y += dt * 0.01
	camera.position.x += (mouse.cartesian.x * 0.1 - camera.position.x) * 0.1
	camera.position.y += (mouse.cartesian.y * 0.1 - camera.position.y) * 0.1 + 10
	camera.lookAt(0,0)

	//controls.update()

	// const geometry = stars.geometry;
	// const attributes = geometry.attributes;

	// raycaster.setFromCamera(pointer, camera);

	// intersects = raycaster.intersectObject(stars);

	// if (intersects.length > 0) {
	// 	let index = intersects[0].index
	// 	console.log(index, `hd ${starId[index]}`, starNames[index], starConst[index])
	// }


	renderer.render(scene, camera)
}

init()
